import React from 'react'
import { SvgIcon } from '@mui/material'

export const ForwardIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M19.92 10.12a1 1 0 0 0-.21-.33l-3-3a1 1 0 1 0-1.42 1.42l1.3 1.29H7a3 3 0 0 0-3 3v4a1 1 0 1 0 2 0v-4a1 1 0 0 1 1-1h9.59l-1.3 1.29a1 1 0 1 0 1.42 1.42l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76Z" />
  </SvgIcon>
)

export const ForwardSmallIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      fill="#55A6FF"
      d="M11.667 7.5V4.167L17.5 10l-5.833 5.833v-3.416c-4.167 0-7.084 1.333-9.167 4.25.833-4.167 3.333-8.334 9.167-9.167Z"
    />
  </SvgIcon>
)
